/* Noir & Lin — theme.js (no dependencies) */
(function () {
  'use strict';

  var NL = window.NL || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------------- Utilities ---------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || NL.moneyFormat || '{{amount}}';
    var rx = /\{\{\s*(\w+)\s*\}\}/;
    function withDelims(n, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var m = format.match(rx);
    var value = '';
    switch (m ? m[1] : 'amount') {
      case 'amount': value = withDelims(cents, 2); break;
      case 'amount_no_decimals': value = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      default: value = withDelims(cents, 2);
    }
    return format.replace(rx, value);
  }
  NL.formatMoney = formatMoney;

  function toast(msg) {
    var t = $('[data-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }
  NL.toast = toast;

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  /* ---------------- Portals (move drawers to <body> so they sit above the sticky header) ---------------- */
  function portal() {
    $$('[data-portal]').forEach(function (el) {
      if (el.parentNode === document.body) return;
      $$('body > #' + el.id).forEach(function (old) { if (old !== el) old.remove(); });
      document.body.appendChild(el);
    });
  }
  portal();
  document.addEventListener('shopify:section:load', portal);

  /* ---------------- Header height ---------------- */
  function setHeaderVars() {
    var h = $('.header-wrap');
    if (!h) return;
    document.documentElement.style.setProperty('--header-offset', h.offsetHeight + 'px');
  }
  window.addEventListener('resize', debounce(setHeaderVars, 150));
  setHeaderVars();

  /* ---------------- Drawers ---------------- */
  var overlay = $('[data-overlay]');
  var openDrawerEl = null;
  var lastFocus = null;

  function openDrawer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    if (openDrawerEl && openDrawerEl !== el) closeDrawer(true);
    lastFocus = document.activeElement;
    el.hidden = false;
    requestAnimationFrame(function () {
      el.classList.add('is-open');
      if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-visible'); }); }
    });
    document.body.classList.add('is-locked');
    openDrawerEl = el;
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = el.querySelector('[data-autofocus]') || el.querySelector('button, [href], input, select, textarea');
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
  }
  function closeDrawer(keepOverlay) {
    if (!openDrawerEl) return;
    var el = openDrawerEl;
    el.classList.remove('is-open');
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    openDrawerEl = null;
    if (!keepOverlay) {
      if (overlay) overlay.classList.remove('is-visible');
      document.body.classList.remove('is-locked');
      setTimeout(function () { if (overlay && !openDrawerEl) overlay.hidden = true; }, 300);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
  }
  NL.openDrawer = openDrawer;
  NL.closeDrawer = closeDrawer;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      if (opener.getAttribute('data-drawer-open') === 'CartDrawer' && NL.cartType !== 'drawer') return;
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target === overlay) closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeLightbox(); }
  });

  /* ---------------- Announcement rotator ---------------- */
  $$('[data-announcement]').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var i = 0;
    var speed = parseInt(bar.getAttribute('data-speed'), 10) || 4500;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, speed);
  });

  /* ---------------- Mobile nav accordions ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-mnav-toggle]');
    if (!t) return;
    var sub = document.getElementById(t.getAttribute('aria-controls'));
    var open = t.getAttribute('aria-expanded') === 'true';
    t.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (sub) sub.hidden = open;
  });

  /* ---------------- Predictive search ---------------- */
  (function () {
    var input = $('[data-search-input]');
    var results = $('[data-search-results]');
    var defaults = $('[data-search-defaults]');
    if (!input || !results) return;
    var controller;
    var run = debounce(function () {
      var q = input.value.trim();
      if (!q) { results.innerHTML = ''; if (defaults) defaults.hidden = false; return; }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = NL.routes.predictiveSearch + '?q=' + encodeURIComponent(q) +
        '&section_id=predictive-search&resources[type]=product,collection,query&resources[limit]=8&resources[options][unavailable_products]=last';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('[data-predictive]');
          results.innerHTML = inner ? inner.innerHTML : '';
          if (defaults) defaults.hidden = true;
        })
        .catch(function () {});
    }, 220);
    input.addEventListener('input', run);
  })();

  /* ---------------- Cart ---------------- */
  var Cart = {
    sections: function () {
      var s = ['cart-drawer'];
      if ($('[data-cart-page]')) s.push($('[data-cart-page]').getAttribute('data-section-id'));
      return s;
    },
    render: function (sections) {
      if (!sections) return;
      if (sections['cart-drawer']) {
        var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var fresh = doc.querySelector('[data-cart-inner]');
        var cur = $('#CartDrawer [data-cart-inner]');
        if (fresh && cur) cur.replaceWith(fresh);
        var count = fresh ? fresh.getAttribute('data-count') : null;
        if (count !== null) {
          $$('[data-cart-count]').forEach(function (el) { el.textContent = count === '0' ? '' : count; el.setAttribute('data-count', count); });
          $$('[data-cart-link]').forEach(function (el) { el.setAttribute('aria-label', 'Cart (' + count + ')'); });
        }
      }
      var page = $('[data-cart-page]');
      if (page) {
        var id = page.getAttribute('data-section-id');
        if (sections[id]) {
          var d2 = new DOMParser().parseFromString(sections[id], 'text/html');
          var f2 = d2.querySelector('[data-cart-page]');
          if (f2) page.replaceWith(f2);
        }
      }
    },
    add: function (items, btn) {
      if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
      return fetch(NL.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: Cart.sections().join(','), sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok || res.json.status) throw new Error(res.json.description || res.json.message || NL.strings.cartError);
          if (NL.cartType === 'page') { window.location.href = NL.routes.cart; return; }
          Cart.render(res.json.sections);
          if (NL.cartType === 'drawer') openDrawer('CartDrawer');
          else toast(NL.strings.added);
          document.dispatchEvent(new CustomEvent('nl:cart:added'));
        })
        .catch(function (err) { toast(err.message || NL.strings.cartError); })
        .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
    },
    change: function (key, qty) {
      var inner = $('#CartDrawer [data-cart-inner]');
      if (inner) inner.style.opacity = '.55';
      return fetch(NL.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: Cart.sections().join(','), sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok || res.json.status) throw new Error(res.json.description || res.json.message || NL.strings.cartError);
          Cart.render(res.json.sections);
        })
        .catch(function (err) { toast(err.message || NL.strings.cartError); var i2 = $('#CartDrawer [data-cart-inner]'); if (i2) i2.style.opacity = ''; });
    },
    note: debounce(function (value) {
      fetch(NL.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: value }) });
    }, 500)
  };
  NL.Cart = Cart;

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-qty-change]');
    if (q && q.closest('[data-line-key]')) {
      e.preventDefault();
      var line = q.closest('[data-line-key]');
      var input = $('input', line.querySelector('.qty'));
      var next = Math.max(0, parseInt(input.value, 10) + parseInt(q.getAttribute('data-qty-change'), 10));
      input.value = next;
      Cart.change(line.getAttribute('data-line-key'), next);
      return;
    }
    var rm = e.target.closest('[data-line-remove]');
    if (rm) {
      e.preventDefault();
      Cart.change(rm.closest('[data-line-key]').getAttribute('data-line-key'), 0);
      return;
    }
    var qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      Cart.add([{ id: parseInt(qa.getAttribute('data-quick-add'), 10), quantity: 1 }], qa);
      return;
    }
    var up = e.target.closest('[data-upsell-add]');
    if (up) {
      e.preventDefault();
      var sel = up.parentNode.querySelector('select');
      var vid = sel ? sel.value : up.getAttribute('data-upsell-add');
      Cart.add([{ id: parseInt(vid, 10), quantity: 1 }], up);
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-key] .qty input');
    if (input) {
      Cart.change(input.closest('[data-line-key]').getAttribute('data-line-key'), Math.max(0, parseInt(input.value, 10) || 0));
    }
    if (e.target.matches('[data-cart-note]')) Cart.note(e.target.value);
  });
  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-cart-note]')) Cart.note(e.target.value);
  });

  /* ---------------- Product form ---------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    if (NL.cartType === 'page' && !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var fd = new FormData(form);
    var item = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) };
    var props = {};
    fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; });
    if (Object.keys(props).length) item.properties = props;
    Cart.add([item], btn);
  });

  /* Quantity steppers (non-cart) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-step]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Variant picker ---------------- */
  $$('[data-product]').forEach(function (root) {
    var dataEl = $('[data-product-json]', root);
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = $('form[data-product-form]', root);
    var idInput = form ? $('input[name=id]', form) : null;
    var fieldsets = $$('[data-option-index]', root);
    var atc = $$('[data-atc]', document);
    var priceEl = $('[data-price]', root);
    var stockEl = $('[data-stock]', root);
    var sticky = $('[data-sticky-atc]');

    function selected() {
      return fieldsets.map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function markAvailability(opts) {
      fieldsets.forEach(function (fs, idx) {
        $$('input', fs).forEach(function (inp) {
          var test = opts.slice();
          test[idx] = inp.value;
          var avail = product.variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return i === idx ? o === inp.value : (i < idx ? o === test[i] : true); });
          });
          var lbl = inp.nextElementSibling;
          if (lbl) lbl.classList.toggle('is-unavailable', !avail);
        });
        var chosen = fs.querySelector('input:checked');
        var out = fs.querySelector('[data-selected-value]');
        if (out && chosen) out.textContent = chosen.value;
      });
    }
    function update() {
      var opts = selected();
      var v = findVariant(opts);
      markAvailability(opts);
      atc.forEach(function (b) {
        var label = b.querySelector('[data-atc-label]') || b;
        if (!v) { b.disabled = true; label.textContent = NL.strings.unavailable; }
        else if (!v.available) { b.disabled = true; label.textContent = NL.strings.soldOut; }
        else { b.disabled = false; label.textContent = NL.strings.addToCart; }
      });
      if (!v) { if (stockEl) stockEl.hidden = true; return; }
      if (idInput) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      if (priceEl) {
        var html = '<span>' + formatMoney(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>' +
            '<span class="price__save">Save ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%</span>';
        }
        priceEl.innerHTML = html;
      }
      if (stockEl) {
        stockEl.hidden = false;
        stockEl.classList.toggle('stock--out', !v.available);
        stockEl.textContent = v.available ? stockEl.getAttribute('data-in') : stockEl.getAttribute('data-out');
      }
      if (sticky) {
        var sm = $('[data-sticky-variant]', sticky);
        if (sm) sm.textContent = v.title + ' · ' + formatMoney(v.price);
      }
      if (v.featured_media) scrollToMedia(v.featured_media.id);
      if (window.history.replaceState && root.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    function scrollToMedia(id) {
      var item = $('[data-media-id="' + id + '"]', root);
      if (!item) return;
      var gal = item.parentNode;
      if (window.matchMedia('(max-width: 989px)').matches) {
        gal.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      } else if (gal.firstElementChild !== item) {
        gal.insertBefore(item, gal.firstElementChild);
      }
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
    markAvailability(selected());

    /* Gallery dots (mobile) */
    var gal = $('[data-gallery]', root);
    var dots = $('[data-gallery-dots]', root);
    if (gal && dots) {
      var items = $$('.gallery__item', gal);
      if (items.length > 1) {
        dots.innerHTML = items.map(function (_, i) { return '<button type="button" aria-label="Go to image ' + (i + 1) + '"' + (i === 0 ? ' class="is-active"' : '') + '></button>'; }).join('');
        var btns = $$('button', dots);
        btns.forEach(function (b, i) { b.addEventListener('click', function () { gal.scrollTo({ left: gal.children[i].offsetLeft, behavior: 'smooth' }); }); });
        gal.addEventListener('scroll', debounce(function () {
          var i = Math.round(gal.scrollLeft / gal.clientWidth);
          btns.forEach(function (b, j) { b.classList.toggle('is-active', i === j); });
        }, 60));
      }
      gal.addEventListener('click', function (e) {
        var it = e.target.closest('.gallery__item');
        if (!it) return;
        openLightbox($$('.gallery__item', gal).indexOf(it), gal);
      });
    }

    /* Sticky ATC */
    var mainAtc = form ? form.querySelector('[data-atc]') : null;
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      var footer = $('.footer');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.target === mainAtc) sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
        });
      });
      io.observe(mainAtc);
      $('[data-sticky-submit]', sticky).addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.querySelector('[type=submit]').click();
      });
      if (footer) new IntersectionObserver(function (en) { if (en[0].isIntersecting) sticky.classList.remove('is-visible'); }).observe(footer);
    }

    /* Recently viewed */
    try {
      var key = 'nl_recent';
      var list = JSON.parse(localStorage.getItem(key) || '[]').filter(function (h) { return h !== product.handle; });
      list.unshift(product.handle);
      localStorage.setItem(key, JSON.stringify(list.slice(0, 12)));
    } catch (err) {}
  });

  /* ---------------- Lightbox ---------------- */
  var lb = null;
  function openLightbox(index, gal) {
    closeLightbox();
    var imgs = $$('img', gal);
    lb = document.createElement('div');
    lb.className = 'lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML = '<button class="icon-btn lightbox__close" type="button" aria-label="Close"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 6l12 12M18 6 6 18"/></svg></button><div class="lightbox__track">' +
      imgs.map(function (im) {
        var src = (im.currentSrc || im.src).replace(/width=\d+/, 'width=2000');
        return '<div class="lightbox__slide"><img src="' + src + '" alt="' + (im.alt || '').replace(/"/g, '&quot;') + '"></div>';
      }).join('') + '</div>';
    document.body.appendChild(lb);
    document.body.classList.add('is-locked');
    var track = $('.lightbox__track', lb);
    requestAnimationFrame(function () { track.scrollLeft = track.clientWidth * index; });
    $('.lightbox__close', lb).addEventListener('click', closeLightbox);
    $('.lightbox__close', lb).focus();
  }
  function closeLightbox() {
    if (!lb) return;
    lb.remove();
    lb = null;
    if (!openDrawerEl) document.body.classList.remove('is-locked');
  }

  /* ---------------- Delivery estimate ---------------- */
  $$('[data-delivery]').forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min'), 10) || 5;
    var max = parseInt(el.getAttribute('data-max'), 10) || 9;
    function addBiz(d, n) { var r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0) n--; } return r; }
    var fmt = function (d) { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); };
    var now = new Date();
    var out = el.querySelector('[data-delivery-range]');
    if (out) out.textContent = fmt(addBiz(now, min)) + ' – ' + fmt(addBiz(now, max));
  });

  /* ---------------- Sliders ---------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-slide]');
    if (!b) return;
    var s = document.getElementById(b.getAttribute('aria-controls'));
    if (!s) return;
    var dir = b.getAttribute('data-slide') === 'next' ? 1 : -1;
    s.scrollBy({ left: dir * s.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* ---------------- Collection filters ---------------- */
  (function () {
    var wrap = $('[data-collection]');
    if (!wrap) return;
    var sectionId = wrap.getAttribute('data-section-id');

    function load(url, push) {
      var grid = $('[data-results]', wrap);
      if (grid) grid.style.opacity = '.4';
      var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;
      fetch(fetchUrl).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-results]', '[data-facets]', '[data-active-filters]', '[data-count]'].forEach(function (sel) {
          var fresh = doc.querySelector(sel);
          $$(sel, wrap).forEach(function (cur) { if (fresh) cur.innerHTML = fresh.innerHTML; });
        });
        var g = $('[data-results]', wrap);
        if (g) g.style.opacity = '';
        if (push) history.pushState({ url: url }, '', url);
        initReveal();
      });
    }
    function formUrl(form) {
      var fd = new FormData(form);
      var params = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') params.append(k, v); });
      var sort = $('[data-sort]', wrap);
      if (sort && sort.value) params.set('sort_by', sort.value);
      return window.location.pathname + '?' + params.toString();
    }
    wrap.addEventListener('change', function (e) {
      var f = e.target.closest('form[data-filter-form]');
      if (f) { load(formUrl(f), true); return; }
      if (e.target.matches('[data-sort]')) {
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', e.target.value);
        params.delete('page');
        load(window.location.pathname + '?' + params.toString(), true);
      }
    });
    wrap.addEventListener('submit', function (e) {
      var f = e.target.closest('form[data-filter-form]');
      if (f) { e.preventDefault(); load(formUrl(f), true); }
    });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-filter-link]');
      if (!a) return;
      e.preventDefault();
      load(a.getAttribute('href'), true);
    });
    window.addEventListener('popstate', function () { load(window.location.href, false); });

    /* "Show results" button in the filter drawer: it used to only close the
       drawer (via data-drawer-close), relying on an earlier `change` event to
       have already applied the filters — unreliable on touch when a shopper
       taps a checkbox and then immediately taps "Show results" before the
       change event's fetch has been kicked off, or when nothing changed but
       the drawer was opened directly. Explicitly (re)apply the current filter
       state on click, then close the drawer, so the button always works. */
    document.addEventListener('click', function (e) {
      var applyBtn = e.target.closest('[data-filter-apply]');
      if (!applyBtn) return;
      var scope = applyBtn.closest('.drawer') || document;
      var f = $('form[data-filter-form]', scope) || $('form[data-filter-form]', wrap);
      if (f) load(formUrl(f), true);
      NL.closeDrawer();
    });

    wrap.addEventListener('click', function (e) {
      var g = e.target.closest('[data-grid-cols]');
      if (!g) return;
      var grid = $('.grid', wrap);
      var cols = g.getAttribute('data-grid-cols');
      $$('[data-grid-cols]', wrap).forEach(function (b) { b.setAttribute('aria-pressed', b === g ? 'true' : 'false'); });
      if (grid) { grid.style.setProperty('--cols', cols); grid.style.setProperty('--cols-m', cols === '2' ? '1' : '2'); }
      try { localStorage.setItem('nl_grid', cols); } catch (err) {}
    });
    try {
      var saved = localStorage.getItem('nl_grid');
      var btn = saved && $('[data-grid-cols="' + saved + '"]', wrap);
      if (btn) btn.click();
    } catch (err) {}
  })();

  /* ---------------- Recently viewed ---------------- */
  $$('[data-recent]').forEach(function (sec) {
    var list;
    try { list = JSON.parse(localStorage.getItem('nl_recent') || '[]'); } catch (e) { list = []; }
    var current = sec.getAttribute('data-current');
    list = list.filter(function (h) { return h !== current; }).slice(0, parseInt(sec.getAttribute('data-limit'), 10) || 4);
    if (!list.length) return;
    var target = $('[data-recent-grid]', sec);
    Promise.all(list.map(function (h) {
      return fetch(NL.routes.root.replace(/\/$/, '') + '/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      var html = products.filter(Boolean).map(function (p) {
        var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
        var sep = img.indexOf('?') > -1 ? '&' : '?';
        var badge = p.available ? '' : '<div class="card__badges"><span class="badge badge--muted">Sold out</span></div>';
        return '<div class="card"><div class="card__media-wrap"><a class="card__media" href="' + p.url + '" tabindex="-1">' +
          (img ? '<img src="' + img + sep + 'width=600" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy" width="600" height="750">' : '') +
          '</a>' + badge + '</div><div class="card__info"><h3 class="card__title"><a href="' + p.url + '">' + p.title + '</a></h3><div class="price"><span>' + formatMoney(p.price) + '</span></div></div></div>';
      }).join('');
      if (html) { target.innerHTML = html; sec.hidden = false; }
    });
  });

  /* ---------------- Country selects ---------------- */
  $$('select[data-default]').forEach(function (s) { var d = s.getAttribute('data-default'); if (d) s.value = d; });

  /* ---------------- Copy ---------------- */
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-copy]');
    if (!c) return;
    var text = c.getAttribute('data-copy');
    var done = function () { toast(NL.strings.copied); };
    if (navigator.clipboard) navigator.clipboard.writeText(text).then(done, done);
    else { var t = document.createElement('textarea'); t.value = text; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (err) {} t.remove(); done(); }
  });

  /* ---------------- Reveal ---------------- */
  function initReveal() {
    var els = $$('.reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }
  initReveal();
  document.addEventListener('shopify:section:load', function () { initReveal(); setHeaderVars(); });

  /* ---------------- Insights popup ---------------- */
  (function () {
    var root = $('[data-popup]');
    if (!root) return;
    var cfg = {
      delay: parseInt(root.getAttribute('data-delay'), 10) || 20,
      expiry: parseInt(root.getAttribute('data-expiry'), 10) || 14,
      cookie: 'nl_popup_seen'
    };
    var isDesignMode = window.Shopify && window.Shopify.designMode;
    var posted = root.hasAttribute('data-posted');
    function seen() { return document.cookie.indexOf(cfg.cookie + '=1') > -1; }
    function markSeen() {
      var d = new Date(); d.setTime(d.getTime() + cfg.expiry * 864e5);
      document.cookie = cfg.cookie + '=1; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
    }
    function open() {
      if (!root.hidden) return;
      root.hidden = false;
      root.setAttribute('data-opened-at', Date.now());
      document.body.classList.add('is-locked');
      var f = root.querySelector('.popup__chips button');
      if (f) f.focus({ preventScroll: true });
      markSeen();
    }
    function close() {
      root.hidden = true;
      document.body.classList.remove('is-locked');
      markSeen();
    }
    NL.openPopup = open;
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

    document.addEventListener('shopify:section:select', function (e) { if (root.closest('.shopify-section') && e.target === root.closest('.shopify-section')) { root.hidden = true; open(); } });
    document.addEventListener('shopify:section:deselect', function (e) { if (root.closest('.shopify-section') && e.target === root.closest('.shopify-section')) close(); });
    if (posted) { open(); return; }
    if (!isDesignMode && !seen()) {
      var fired = false;
      var pendingTrigger = false;

      /* Don't let the popup cover an open size/cart drawer: if either is open
         when the popup would fire, hold off (without consuming the one-shot
         `fired` flag) and watch for the drawer to close so it can fire right
         after, instead of the trigger being silently lost. */
      function isDrawerOpen(id) {
        var el = document.getElementById(id);
        return !!el && el.hidden === false && el.classList.contains('is-open');
      }
      function anyGuardedDrawerOpen() {
        return isDrawerOpen('SizeDrawer') || isDrawerOpen('CartDrawer');
      }
      var trigger = function () {
        if (fired) return;
        if (anyGuardedDrawerOpen()) { pendingTrigger = true; return; }
        fired = true;
        open();
      };
      ['SizeDrawer', 'CartDrawer'].forEach(function (id) {
        var el = document.getElementById(id);
        if (!el || !('MutationObserver' in window)) return;
        new MutationObserver(function () {
          if (pendingTrigger && !fired && !anyGuardedDrawerOpen()) {
            pendingTrigger = false;
            trigger();
          }
        }).observe(el, { attributes: true, attributeFilter: ['class', 'hidden'] });
      });
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0) trigger();
      });
      setTimeout(trigger, cfg.delay * 1000);
    }

    /* Chips */
    root.addEventListener('click', function (e) {
      var chip = e.target.closest('.popup__chips button');
      if (!chip) return;
      chip.setAttribute('aria-pressed', chip.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
    });

    var form = root.closest('form') || root.querySelector('form');
    if (!form) return;
    var steps = $$('[data-step-panel]', root);
    var progress = $$('.popup__progress span', root);
    var step = 0;
    function show(i) {
      steps.forEach(function (s, j) { s.hidden = j !== i; });
      progress.forEach(function (p, j) { p.classList.toggle('is-on', j <= i); });
      step = i;
    }
    function collect(panel) {
      var chosen = $$('.popup__chips button[aria-pressed=true]', panel).map(function (b) { return b.textContent.trim(); });
      var other = $('textarea, input[type=text]', panel);
      return { chosen: chosen, other: other ? other.value.trim() : '' };
    }
    root.addEventListener('click', function (e) {
      var next = e.target.closest('[data-popup-next]');
      if (!next) return;
      e.preventDefault();
      var panel = steps[step];
      var res = collect(panel);
      var err = $('.popup__err', panel);
      if (!res.chosen.length && !res.other) { if (err) err.hidden = false; return; }
      if (err) err.hidden = true;
      var hidden = $('[data-answer]', panel);
      if (hidden) hidden.value = res.chosen.join(', ');
      show(step + 1);
    });
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target.matches('input[type=text]')) return;
      if (step < steps.length - 1) {
        e.preventDefault();
        var nb = $('[data-popup-next]', steps[step]);
        if (nb) nb.click();
      }
    });
    form.addEventListener('submit', function (e) {
      var hp = form.querySelector('[name="contact[website]"]');
      var opened = parseInt(root.getAttribute('data-opened-at'), 10) || 0;
      var email = form.querySelector('[type=email]');
      var err = form.querySelector('[data-email-error]');
      if (hp && hp.value) { e.preventDefault(); close(); return; }
      if (opened && Date.now() - opened < 1200) { e.preventDefault(); return; }
      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
        e.preventDefault();
        if (err) err.hidden = false;
        email.focus();
        return;
      }
      if (err) err.hidden = true;
      steps.forEach(function (s) {
        var hidden = $('[data-answer]', s);
        if (hidden && !hidden.value) hidden.value = collect(s).chosen.join(', ');
      });
    });
    show(0);
  })();
})();
